import { HttpParams } from '@angular/common/http';
import { Tierliste } from '../../gruppe-tier/classes/tierliste';

/** Global lists (`mehrere_gruppen > 0`) may add animals from any group of the farm. */
export function isAbgangTierlisteGlobal(tierliste: Tierliste | null | undefined): boolean {
    return Number(tierliste?.mehrere_gruppen || 0) > 0;
}

export interface AbgangTierLookupOptions {
    /** Groups chosen on the Gruppe step (one id or many for „Global“). */
    browseGruppeIds?: number[] | null;
    /** Selected Betrieb when the tierliste has no `kunde_id_abgang` (Kundenportal). */
    kundeIdFallback?: number | null;
}

export function getAbgangTierKundeId(
    tierliste: Tierliste | null | undefined,
    kundeIdFallback?: number | null,
): number {
    return Number(tierliste?.kunde_id_abgang || kundeIdFallback || 0);
}

function normalizeBrowseGruppeIds(options?: AbgangTierLookupOptions): number[] {
    const fromList = (options?.browseGruppeIds || []).map(id => Number(id)).filter(id => id > 0);
    if (fromList.length > 0) {
        return [...new Set(fromList)];
    }
    return [];
}

/**
 * Restrict animal lookup to groups from the Ausstallen Gruppe step.
 * Uses `gruppe_id` (one group) or `gruppe_ids` (comma-separated, from UI list).
 */
export function appendAbgangTierLookupGruppeFilter(
    params: HttpParams,
    tierliste: Tierliste | null | undefined,
    options?: AbgangTierLookupOptions,
): HttpParams {
    const gruppeIds = normalizeBrowseGruppeIds(options);
    if (gruppeIds.length === 1) {
        return params.set('gruppe_id', String(gruppeIds[0]));
    }
    if (gruppeIds.length > 1) {
        return params.set('gruppe_ids', gruppeIds.join(','));
    }

    if (isAbgangTierlisteGlobal(tierliste)) {
        const kundeId = getAbgangTierKundeId(tierliste, options?.kundeIdFallback);
        if (kundeId > 0) {
            return params.set('kunde_id', String(kundeId));
        }
        return params.set('alle_gruppen', '1');
    }

    const gruppeId = Number(tierliste?.gruppe_id_abgang || 0);
    if (gruppeId > 0) {
        return params.set('gruppe_id', String(gruppeId));
    }
    const kundeId = getAbgangTierKundeId(tierliste, options?.kundeIdFallback);
    if (kundeId > 0) {
        return params.set('kunde_id', String(kundeId));
    }
    return params.set('alle_gruppen', '1');
}
